import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteCustomDeduction, selectCustomDeduction, toggleEditDeductionModal, updatePayStructure } from 'store/entities/payroll/payrollSetup/action';
import CustomSwitch from 'components/__new/common/form/CustomSwitch';
import { toast } from 'react-toastify';

    const ViewDeductionsTab = ({pensionShared, setModalOpen, deductionSubmitRef, isViewing, form, setForm}) => {
    const {useSelector, dispatch, lettersRegex, formatDeductionType} = usePayrollEssentials();
    const {customDeductions} = useSelector((state) => state.entities.payrollSetup);

    const pensionActive = form?.deductions?.pension_deduction?.is_enabled

    const saveDefaultDeduction = (e) => {
        e.preventDefault();
        
        const emptyItem = form?.salary_breakdown?.find((item) => !item?.salary_component?.length || Number(item.percentage) < 0);
        const result = form?.salary_breakdown?.reduce((acc, item) => acc + Number(item.percentage), 0);

        if (!lettersRegex.test(form?.name)) {
            toast.error('Pay structure name must contain letters')
        } else if(form?.name?.length < 3) {
            toast.error('Pay structure name be at least 3 characters')
        } else if(emptyItem) {
            toast.error('Please fill or delete empty fields')
        } else if(result !== 100) {
            toast.error('Total salary breakdown must be 100%')
        } else {
            const removeIDs = (data) => {
            return data?.map((item) => {
            const newObj = {};
            for (let key in item) {
                if (key !== "id") {
                    newObj[key] = item[key];
                }
            }
                return newObj;
            })
            }

            const payload = {
                ...form,
                salary_breakdown: removeIDs(form?.salary_breakdown?.map((item) => ({...item, percentage: Number(item.percentage)}))),
                deductions: {
                    ...form.deductions,
                    custom_deductions: removeIDs(customDeductions),
                    pension_deduction: {
                        ...form.deductions.pension_deduction,
                        pension_scheme: pensionActive ? pensionShared ? "EMPLOYER_10_PERCENT_EMPLOYEE_8_PERCENT" : "GROUP_20" : null
                    }
                }
            }
            dispatch(updatePayStructure(payload));
        }
    }

    return (
        <div>
                <div className="structure-wrap">
                    <p className="structure-text">Statutory deductions</p>
                    <div className="structure-input bg-white p-4">
                        <form onSubmit={saveDefaultDeduction}>
                            <div className="w-full">
                                <div className="w-full flex-btw">
                                    <div>
                                        <label className='text-xs font-semibold text-ep-primary-600'>Pension</label>
                                        <p style={{fontSize: '11px'}} className="mb-0 text-xs lt-gray">Employer (10% of BHT) + Employee Contribution <br /> (8% of BHT)</p>
                                    </div>

                                    <div className="flex items-start">
                                        <CustomSwitch disabled={isViewing} active={form?.deductions?.pension_deduction?.is_enabled || false} onChange={() => {
                                            setForm({
                                                ...form,
                                                deductions: {
                                                    ...form.deductions,
                                                    pension_deduction: {...form.deductions.pension_deduction, is_enabled: !form?.deductions?.pension_deduction?.is_enabled}
                                                }
                                            })
                                        }} />
                                    </div>
                                </div>
                            </div>

                            <hr className="deduct-divider" />

                            <div className="w-full flex-btw">
                                <div>
                                    <label className='text-xs font-semibold text-ep-primary-600'>NHF</label>
                                    <p style={{fontSize: '11px'}} className="mb-0 text-xs lt-gray">National Housing Fund</p>
                                </div>
                                <div className="flex items-start">
                                    <CustomSwitch disabled active={form?.deductions?.nhf || false} onChange={() => {
                                            setForm({
                                                ...form,
                                                deductions: {
                                                    ...form.deductions,
                                                    nhf: !form?.deductions?.nhf
                                                }
                                            })
                                        }} />
                                </div>
                            </div>
                            <hr className="deduct-divider" />

                            <div className="w-full flex-btw">
                                <div>
                                    <label className='text-xs font-semibold text-ep-primary-600'>NSITF</label>
                                    <p style={{fontSize: '11px'}} className="mb-0 text-xs lt-gray">Nigeria Social Insurance Trust Fund</p>
                                </div>
                                <div className="flex items-start">
                                    <CustomSwitch disabled active={form?.deductions?.nsitf || false} onChange={() => {
                                            setForm({
                                                ...form,
                                                deductions: {
                                                    ...form.deductions,
                                                    nsitf: !form?.deductions?.nsitf
                                                }
                                            })
                                        }} />
                                </div>
                            </div>
                            <hr className="deduct-divider" />

                            <div className="w-full flex-btw">
                                <div>
                                    <label className='text-xs font-semibold text-ep-primary-600'>ITF</label>
                                    <p style={{fontSize: '11px'}} className="mb-0 text-xs lt-gray">Industrial Training Fund</p>
                                </div>
                                <div className="flex items-start">
                                    <CustomSwitch disabled active={form?.deductions?.itf || false} onChange={() => {
                                            setForm({
                                                ...form,
                                                deductions: {
                                                    ...form.deductions,
                                                    itf: !form?.deductions?.itf
                                                }
                                            })
                                        }} />
                                </div>
                            </div>
                            <hr className="deduct-divider" />
                                <button ref={deductionSubmitRef} style={{display: 'none'}} type="submit">Save Deduction</button>
                        </form>
                    </div>
                </div>

                <div className="w-full py-4">
                    <div className="structure-wrap">
                        <p className="structure-text">Custom Deduction Items</p>
                        <div className="structure-input">
                                {customDeductions?.length > 0 && customDeductions.map((item, idx) => {
                                    const deductTypeFixed = item.type === 'FIXED_AMOUNT'
                                    return <div key={idx} className="bg-white p-4 mb-8">
                                                <div className="flex-btw items-center w-full">
                                                    <div className="w-3/4">
                                                    <input type="text" disabled placeholder={item.name} className="form-input" />
                                                    </div>
                                                    {!isViewing && <div className="w-max flex-btw">
                                                        <FontAwesomeIcon onClick={() => {
                                                            dispatch(selectCustomDeduction(item))
                                                            dispatch(toggleEditDeductionModal())
                                                        }} icon="pencil-alt"
                                                        className="text-ep-primary-500 mr-5 cursor-pointer"/>

                                                        <FontAwesomeIcon onClick={() => dispatch(deleteCustomDeduction(item.id))} icon="trash-alt"
                                                        className="text-red-500 cursor-pointer"/>
                                                    </div>}
                                                </div>
                                                <p className="my-3 text-xs lt-gray">{item.description}</p>
                                                <hr />
                                                <div className="flex-btw items-center w-full my-4">
                                                    <div className="w-2/4 text-xs">
                                                        <p className="prl-orng mb-0">Deduction Type:</p>
                                                        <p className="text-black text-xs  capitalize">{deductTypeFixed ? 'Fixed Amount' : item?.type?.toLowerCase()}</p>
                                                    </div>
                                                    <div className="w-2/4 text-xs flex items-center justify-end">
                                                        <div>
                                                        <p className="prl-orng mb-0">Deduction Source:</p>
                                                        <p className="text-black text-xs">{formatDeductionType(item.source)}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                    <div className="w-2/4 text-xs mt-3">
                                                        <p className="prl-orng mb-0">Deduction Value:&nbsp; <span className="text-black">{deductTypeFixed ? `₦${item.value.toLocaleString()}`  : `${item.value}%`}</span></p>
                                                    </div>
                                            </div>
                                        })}

                                <div className="w-full">
                                    <button onClick={() => setModalOpen(true)} className="mt-4 text-ep-primary-600">
                                        + Add item
                                    </button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
    )
}

export default ViewDeductionsTab